import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const isAdminArea = location.pathname.startsWith("/admin");

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#1A2744]">
        <div className="flex items-center gap-3">
          <div className="h-3 w-3 rounded-full bg-[#C9A84C] animate-pulse"></div>
          <span className="font-medium">Loading…</span>
        </div>
      </div>
    );
  }

  // Not signed in → send to the matching login page
  if (!user) {
    const loginPath = isAdminArea ? "/admin/login" : "/login";
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  // Signed in but wrong role → send to their own home
  if (roles && !roles.includes(user.role)) {
    let home = "/clock";
    if (user.role === "ADMIN" || user.role === "SUPERADMIN") home = "/admin";
    else if (user.role === "MANAGER") home = "/admin/manager/dashboard";
    return <Navigate to={home} replace />;
  }

  return children;
}
